import { jsxs as l, jsx as C } from "react/jsx-runtime";
import { getIconStyles as o } from "../styles.js";
const r = (e) => /* @__PURE__ */ l(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: o(e),
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.4393 10.9393C12.7206 10.658 13.1022 10.5 13.5 10.5H15C15.3978 10.5 15.7794 10.658 16.0607 10.9393C16.342 11.2206 16.5 11.6022 16.5 12V12.75H17.25C17.6478 12.75 18.0294 12.908 18.3107 13.1893C18.592 13.4706 18.75 13.8522 18.75 14.25V15.75C18.75 16.1478 18.592 16.5294 18.3107 16.8107C18.0294 17.092 17.6478 17.25 17.25 17.25H16.5V18C16.5 18.3978 16.342 18.7794 16.0607 19.0607C15.7794 19.342 15.3978 19.5 15 19.5H13.5C13.1022 19.5 12.7206 19.342 12.4393 19.0607C12.158 18.7794 12 18.3978 12 18V17.25H11.25C10.8522 17.25 10.4706 17.092 10.1893 16.8107C9.90804 16.5294 9.75 16.1478 9.75 15.75V14.25C9.75 13.8522 9.90804 13.4706 10.1893 13.1893C10.4706 12.908 10.8522 12.75 11.25 12.75H12V12C12 11.6022 12.158 11.2206 12.4393 10.9393ZM15 12H13.5V13.5C13.5 13.9142 13.1642 14.25 12.75 14.25H11.25V15.75H12.75C13.1642 15.75 13.5 16.0858 13.5 16.5V18H15V16.5C15 16.0858 15.3358 15.75 15.75 15.75H17.25V14.25H15.75C15.3358 14.25 15 13.9142 15 13.5V12Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.25 3C2.05109 3 1.86032 3.07902 1.71967 3.21967C1.57902 3.36032 1.5 3.55109 1.5 3.75V19.5C1.5 19.8978 1.65804 20.2794 1.93934 20.5607C2.22064 20.842 2.60218 21 3 21C3.39782 21 3.77936 20.842 4.06066 20.5607C4.34196 20.2794 4.5 19.8978 4.5 19.5V8.25C4.5 7.83579 4.83579 7.5 5.25 7.5H23.25C23.6642 7.5 24 7.83579 24 8.25V19.5C24 20.2957 23.6839 21.0587 23.1213 21.6213C22.5587 22.1839 21.7957 22.5 21 22.5H3C2.20435 22.5 1.44129 22.1839 0.87868 21.6213C0.316071 21.0587 0 20.2956 0 19.5V3.75C0 3.15326 0.237053 2.58097 0.65901 2.15901C1.08097 1.73705 1.65326 1.5 2.25 1.5H8.25C8.84674 1.5 9.41903 1.73705 9.84099 2.15901C10.2629 2.58097 10.5 3.15326 10.5 3.75V4.5H20.25C20.6642 4.5 21 4.83579 21 5.25C21 5.66421 20.6642 6 20.25 6H10.5C10.1022 6 9.72064 5.84196 9.43934 5.56066C9.15804 5.27936 9 4.89783 9 4.5V3.75C9 3.55109 8.92098 3.36032 8.78033 3.21967C8.63968 3.07902 8.44891 3 8.25 3H2.25ZM5.59808 21H21C21.3978 21 21.7794 20.842 22.0607 20.5607C22.342 20.2794 22.5 19.8978 22.5 19.5V9H6V19.5C6 20.0312 5.85913 20.5478 5.59808 21Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
export {
  r as CardPatientFolderIcon
};
//# sourceMappingURL=CardPatientFolderIcon.js.map
